import '../styles/MaintenancePage.scss';

const MaintenancePage = () => {
    return (
        <div className="maintenance-container">
            <div className="maintenance-content">
                <div className="maintenance-icon">🛠️</div>
                <h1>Site Under Maintenance</h1>
                <p>
                    We're currently performing some updates to improve your experience.<br />
                    Please check back shortly.
                </p>
            </div>
        </div>

    );
};

export default MaintenancePage;
